{
  "decrease": "Upadati {fieldLabel}",
  "increase": "Povečajte {fieldLabel}",
  "numberField": "Številčno polje"
}
